import React from 'react';
import { useSelector } from 'react-redux';
import CardKeyValue from '../../../../card/cardKeyValue';
import { getObjectCurriculumElementsDR } from '../../utils';
import TextNotAssigned from '../../../../text/TextNotAssigned';

const CardsBasicInformation = () => {
  const formData = useSelector((state) => state?.class?.form || {});
  const subjects = useSelector((state) => state?.subject?.list || []);
  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {});
  const years = useSelector((state) => state?.tenant?.years || []);
  const existLinceseAssessment = useSelector((state) =>
    state?.tenant?.license?.find((license) => license.code === 'assessment')
  );

  const curriculumElements = getObjectCurriculumElementsDR(
    currentCurriculum?.elements,
    currentCurriculum?.elementsStructure,
    formData?.curriculumElements || {}
  );

  const subject = subjects.find((item) => item._id === formData.subjectId);
  const yearLevel = formData.yearLevel?.map((item) => years.find((year) => year._id === item)?.name);

  return (
    <div className='flex flex-nowrap gap-4 pb-4 items-strech justify-center overflow-auto'>
      {formData.code && (
        <CardKeyValue
          className='min-w-100px max-w-150px'
          title='Code'
          lines={2}
          value={formData.code || ''}
        />
      )}
      {formData.name && (
        <CardKeyValue
          className='min-w-100px max-w-150px'
          title='Name'
          lines={2}
          value={formData.name || ''}
        />
      )}
      <CardKeyValue
        className='min-w-100px max-w-150px'
        title='Year level'
        lines={2}
        value={yearLevel?.join(', ') || ''}
      />
      {existLinceseAssessment && !formData?.curriculumId && (
        <CardKeyValue
          className='min-w-100px max-w-150px'
          title='Curriculum'
          lines={2}
          value={<TextNotAssigned />}
        />
      )}
      {existLinceseAssessment && curriculumElements?.element?.keyName && (
        <CardKeyValue
          className='min-w-100px max-w-150px'
          lines={2}
          title={curriculumElements.element.keyName}
          value={curriculumElements.element.valueName || <TextNotAssigned />}
        />
      )}
      {existLinceseAssessment && curriculumElements?.subElement?.keyName && (
        <CardKeyValue
          className='min-w-100px max-w-150px'
          lines={2}
          title={curriculumElements.subElement.keyName}
          value={curriculumElements.subElement.valueName || <TextNotAssigned />}
        />
      )}
      {existLinceseAssessment && curriculumElements?.element?.keyName && subjects.length > 0 && (
        <CardKeyValue
          className='min-w-100px max-w-150px'
          lines={2}
          title='Subject'
          value={subject?.name || <TextNotAssigned />}
        />
      )}
    </div>
  );
};

export default CardsBasicInformation;
